export const menuItems = [
    // DASHBOARDS

    {
        id: 1,
        label: "menuitems.menu.dashboards",
        icon: "bx bxs-dashboard",
        subItems: [
            {
                id: 10,
                label: "menuitems.dashboards.users",
                icon: "bx bx-user-circle",
                link: "/dashboard/users",
                parentId: 1,
            },
            {
                id: 11,
                label: "menuitems.dashboards.financial",
                icon: "bx bx-dollar-circle",
                link: "/dashboard/financials",
                parentId: 1,
            },
            {
                id: 12,
                label: "menuitems.dashboards.app",
                icon: "bx bxs-dashboard",
                subItems: [
                    {
                        id: 120,
                        label: "menuitems.dashboards.likes",
                        link: "/dashboard/likes",
                        parentId: 12,
                    },
                    {
                        id: 121,
                        label: "menuitems.dashboards.score",
                        link: "/dashboard/score",
                        parentId: 12,
                    },
                    {
                        id: 122,
                        label: "menuitems.dashboards.reviews",
                        link: "/dashboard/reviews",
                        parentId: 12,
                    },
                    {
                        id: 123,
                        label: "menuitems.dashboards.firebase",
                        link: "/dashboard/firebase",
                        parentId: 12,
                    }
                ]
            }
        ]
    },

    // MEMBERS

    {
        id: 2,
        label: "menuitems.members.text",
        icon: "bx bx-user-pin",
        subItems: [
            {
                id: 20,
                label: "menuitems.members.search",
                icon: "bx bx-search-alt",
                link: "/users/search",
                parentId: 2
            },
            /*{
                id: 25,
                label: "menuitems.members.fix_qrIndex",
                icon: "bx bx-trending-up",
                link: "/users/fix-qrindex",
                parentId: 2
            },
            {
                id: 26,
                label: "menuitems.members.fix_event_users",
                icon: "bx bxs-like",
                link: "/users/fix-event-users",
                parentId: 2
            },*/
            {
                id: 27,
                label: "menuitems.members.beautiful_users",
                icon: "bx bxs-coin-stack",
                link: "/users/beautiful-users",
                parentId: 2
            },
            {
                id: 28,
                label: "menuitems.members.specials",
                icon: "bx bxs-coin-stack",
                link: "/users/specials-users",
                parentId: 2
            },
        ]
    },

    // MODERATION

    {
        id: 7,
        label: "menuitems.moderation.text",
        icon: "bx bx-check",
        subItems: [
            {
                id: 70,
                label: "menuitems.members.media",
                icon: "bx bx-image-alt",
                link: "/users/media",
                parentId: 7
            },
            {
                id: 75,
                label: "menuitems.members.featured_media",
                icon: "bxs bxs-video",
                link: "/users/featured-media",
                parentId: 7
            },
            {
                id: 71,
                label: "menuitems.members.videolikes",
                icon: "bxs bxs-video",
                link: "/users/videolikes",
                parentId: 7
            },
            {
                id: 72,
                label: "menuitems.members.updates",
                icon: "bx bxs-edit",
                link: "/users/updates",
                parentId: 7
            },
            {
                id: 74,
                label: "menuitems.moderation.checks",
                icon: "bx bxs-check",
                link: "/moderation/checks",
                parentId: 7
            },
            {
                id: 75,
                label: "menuitems.system.ai_stats",
                link: "/system/ai-stats",
                parentId: 6
            },
        ]
    },

    // SUPPORT

    {
        id: 3,
        label: "menuitems.support.text",
        icon: "bx bx-support",
        subItems: [
            {
                id: 30,
                label: "menuitems.support.tickets",
                link: "/support/tickets",
                parentId: 3
            },
            {
                id: 31,
                label: "menuitems.support.reports",
                link: "/support/reports",
                parentId: 3
            },
            {
                id: 32,
                label: "menuitems.support.store_reviews",
                link: "/support/store-reviews",
                parentId: 3
            },
        ]
    },

    // MARKETING

    {
        id: 4,
        label: "menuitems.marketing.text",
        icon: "bx bx-stats",
        subItems: [
            {
                id: 40,
                label: "menuitems.marketing.installs",
                link: "/marketing/installs",
                parentId: 4
            },
            {
                id: 41,
                label: "menuitems.marketing.leads",
                link: "/marketing/leads",
                parentId: 4
            },
            {
                id: 42,
                label: "menuitems.marketing.updates",
                link: "/marketing/updates",
                parentId: 4
            },
            {
                id: 43,
                label: "menuitems.marketing.uninstalls",
                link: "/marketing/uninstalls",
                parentId: 4
            },
        ]
    },

    // FINANCE

    {
        id: 5,
        label: "menuitems.finance.text",
        icon: "bx bxs-dollar-circle",
        subItems: [
            {
                id: 50,
                label: "menuitems.finance.transactions",
                link: "/finance/transactions",
                parentId: 5
            },
            {
                id: 51,
                label: "menuitems.finance.subscriptions",
                link: "/finance/subscriptions",
                parentId: 5
            },
            {
                id: 52,
                label: "menuitems.finance.packs",
                link: "/finance/packs",
                parentId: 5
            },
            {
                id: 53,
                label: "menuitems.finance.stats",
                link: "/finance/stats",
                parentId: 5
            },
            {
                id: 54,
                label: "menuitems.finance.priceGroups",
                link: "/finance/prices-test",
                parentId: 5
            },
            {
                id: 55,
                label: "menuitems.finance.slGroups",
                link: "/finance/slgroups",
                parentId: 5
            },
            {
                id: 56,
                label: "menuitems.finance.pmGroups",
                link: "/finance/pmgroups",
                parentId: 5
            },
            {
                id: 57,
                label: "menuitems.finance.vat_generator",
                link: "/finance/vat",
                parentId: 5
            },
        ]
    },


    // System

    {
        id: 6,
        label: "menuitems.system.text",
        icon: "dripicons-pulse",
        subItems: [
            {
                id: 60,
                label: "menuitems.system.actions",
                link: "/system/actions",
                parentId: 6
            },
            {
                id: 61,
                label: "menuitems.system.notifications",
                link: "/system/notifications",
                parentId: 6
            },
            {
                id: 62,
                label: "menuitems.system.emails",
                link: "/system/emails",
                parentId: 6
            },
            {
                id: 63,
                label: "menuitems.system.generator",
                link: "/system/generator",
                parentId: 6
            },
            {
                id: 64,
                label: "menuitems.system.actions_generator",
                link: "/system/answers",
                parentId: 6
            },
            {
                id: 65,
                label: "menuitems.system.ai_generator",
                link: "/system/ai-generator",
                parentId: 6
            }
        ]
    },

];

